import { escapedRegex } from 'utils';

export const getTechList = ({ searchVal, techs }) => {
  if (searchVal) {
    let filterTechs = techs.filter(t => escapedRegex(searchVal).test(t.name));
    return filterTechs;
  }
  return techs;
}

export const getVendorList = ({ searchVal, vendors }) => {
  if (searchVal) {
    let filterVendors = vendors.filter(v => escapedRegex(searchVal).test(v.name));
    return filterVendors;
  }
  return vendors;
}

export const getAdminList = ({ searchVal, admins }) => {
  if (searchVal) {
    let filterAdmins = admins.filter(a => escapedRegex(searchVal).test(a.name));
    return filterAdmins;
  }
  return admins;
}